export const SESSION_INFO = 'sessionInfo';
